// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import App from './App'
import router from './router'
import Questrial from 'typeface-questrial'
import VueSmoothScroll from 'vue2-smooth-scroll'

import '@/plugins'
import '@/components'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  ...App
})

Vue.use(VueSmoothScroll)
Vue.use(Questrial)


// WEBPACK FOOTER //
// ./src/main.js